/**
 * Rol → yetki matrisi.
 *
 * Tek kaynak burada: hem arayüz (menü/düğme gizleme) hem API (uç koruması)
 * aynı listeyi okur. Kabul kriteri "SATIS rolü maliyet/kâr ve faturasız
 * modülünü hiçbir uçtan göremiyor (API dahil)" ancak böyle garanti edilir —
 * arayüzde gizlemek yetmez.
 */
export const ROLES = ['ADMIN', 'OPERASYON', 'SAHA', 'SATIS', 'MUHASEBE_RO'];
export const ROLE_LABEL = {
    ADMIN: 'Yönetici',
    OPERASYON: 'Operasyon',
    SAHA: 'Saha',
    SATIS: 'Satış',
    MUHASEBE_RO: 'Muhasebe (salt okunur)',
};
export const CAPS = [
    'dashboard.view',
    // Stok
    'stock.view',
    'stock.write', // elle çıkış, sayım düzeltmesi
    'stock.import', // Excel içe aktarım
    'stock.code_change', // ürün kodu değiştirme — eski kod alias'a düşer
    'product.write', // ürün tanımı (teklifteki hızlı tanım dahil)
    // Alış / eşleme
    'purchase.view',
    'purchase.match', // faturaya bağla
    // Teklif
    'quote.view',
    'quote.write',
    'quote.cost', // maliyet/kâr görünürlüğü
    'quote.margin', // teklifte alış iskontosu ve kâr (satış temsilcisi de görür; 10.10.2026 kararı)
    'quote.approve_over_cap', // iskonto TAVANINI aşan satırı onaylayıp geçme
    // Faturasız + tahsilat
    'informal.view',
    'informal.write',
    'receivable.view',
    'receivable.write',
    // Borç hatırlatma (SMS + e-posta)
    'reminder.view', // borçlular, kuyruk, geçmiş
    'reminder.send', // elle gönder, onayla, iptal et, cariyi kapat
    'reminder.settings', // servis ayarı, şablonlar, deneme iletisi
    // Kasa · banka · emanet (docs/KASA-BANKA.md). Gayriresmî hesap ayrıca `informal.view` ister.
    'cash.view',
    'cash.write', // hareket, virman, iptal
    'cash.settings', // hesap ve işlem kategorisi tanımı, muhasebe programıyla ilişkilendirme
    // Çek / senet ve kredi (docs/CEK-SENET-KREDI.md). Nakit yazan adımlar ayrıca `cash.write`,
    // gayriresmî kayıtlar ayrıca `informal.view` ister.
    'cheque.view',
    'cheque.write', // çek / senet girme, durum değiştirme, toplu işlem, iptal
    'loan.view',
    'loan.write', // kredi ve ödeme planı tanımı, taksit ödeme, erken kapama
    // Dönem (yıl): docs/DONEM.md. Kapanış fotoğrafının gayriresmî satırları ayrıca `informal.view` ister.
    'period.view',
    'period.manage', // yeni dönemi aç, dönemi kapat, fotoğrafı tazele
    'period.reopen', // kapalı dönemi yeniden aç — YALNIZ yönetici
    // Fason
    'fason.view',
    'fason.write',
    // Sipariş hattı
    'order.view',
    'order.write',
    // Resmî belge (e-Fatura / e-Arşiv) ve irsaliye: GERİ ALINAMAZ — yalnız yönetici ve muhasebe.
    'invoice.issue',
    // Yönetim
    'settings.view',
    'settings.write',
    'audit.view',
    'user.manage',
];
/**
 * OPERASYON = her şey.
 *
 * Şartname "ayarlar hariç her şey" diyordu; müşteri 12.09.2026'da bunu
 * değiştirdi: "her şeyi Mehmetcan yapabilecek". Mehmetcan kilit kullanıcı ve
 * hedef cümle "ben yokken de iş yürüsün" — eşik, hatırlatma günü, minimum
 * iskonto tablosu ya da yeni kullanıcı açma için Buğra'yı beklemek o cümleyle
 * çelişir. Bu yüzden ayarlar, kayıt izi ve kullanıcı yönetimi de açık.
 *
 * Sonuç: OPERASYON ile ADMIN yetki olarak AYNI. Ayrım rol adında duruyor; ileride
 * bir şey kısıtlanmak istenirse tek satır (aşağıdaki listeden çıkarmak) yeterli.
 *
 * İSTİSNALAR: `invoice.issue` (10.10.2026) — resmî belge kesmek geri alınamaz; yalnız ADMIN ve
 * muhasebe rolünde. `period.reopen` (13.10.2026) — kapalı dönemi yeniden açmak yalnız ADMIN'de
 * (dönemi açmak ve kapatmak OPERASYON'da da var).
 */
const OPERASYON_CAPS = CAPS.filter((c) => c !== 'invoice.issue' && c !== 'period.reopen');
/**
 * SAHA (Burak): faturasız çıkış girer, stoğu görür.
 * Maliyet/kâr ve TAHSİLAT TOPLAMLARINI göremez — şartname 0. bölüm.
 * Faturasız haneyi görür, çünkü çıkışı oraya yazıyor.
 */
const SAHA_CAPS = [
    'dashboard.view',
    'stock.view',
    'informal.view', 'informal.write',
];
/** SATIS (Hüseyin): yalnız teklif + stok görüntüleme. Maliyet ve faturasız taraf YOK. */
const SATIS_CAPS = [
    'dashboard.view',
    'stock.view',
    'product.write',
    'quote.view', 'quote.write', 'quote.margin',
    'order.view', 'order.write',
];
/**
 * MUHASEBE_RO: resmî tarafın salt okunur görünümü. Faturasız taraf YOK.
 * Borç hatırlatmada görür ve gönderir; ama faturasız alacak kalemi ona hiç gelmez
 * (API'de `informal.view` ile süzülür) — yalnız fatura ve sipariş ödemesi üzerinden çalışır.
 * SAHA ve SATIS tahsilat toplamlarını görmediği için hatırlatma ekranını da görmez.
 * Tek yazma yetkisi `invoice.issue`: fatura kaydını resmîleştirir, irsaliye açar
 * (panelde ayrı bir "muhasebe" rolü yok; rol adı tarihsel).
 */
const MUHASEBE_CAPS = [
    'dashboard.view',
    'stock.view',
    'purchase.view',
    'quote.view',
    'order.view',
    'reminder.view', 'reminder.send',
    // Kasa ve banka: salt okunur ve YALNIZ resmî hesaplar (`informal.view` yok → gayriresmî API'de süzülür).
    'cash.view',
    // Çek / senet ve kredi: salt okunur ve YALNIZ resmî olanlar (gayriresmî API'de süzülür).
    'cheque.view',
    'loan.view',
    // Dönemler: salt okunur; kapanış fotoğrafının yalnız resmî satırları.
    'period.view',
    'invoice.issue',
];
export const ROLE_CAPS = {
    ADMIN: CAPS,
    OPERASYON: OPERASYON_CAPS,
    SAHA: SAHA_CAPS,
    SATIS: SATIS_CAPS,
    MUHASEBE_RO: MUHASEBE_CAPS,
};
export function can(role, cap) {
    return ROLE_CAPS[role].includes(cap);
}
/** Birden fazla yetkiden herhangi biri yeterliyse. */
export function canAny(role, caps) {
    return caps.some((c) => can(role, c));
}
